import { render, staticRenderFns } from "./BrandUsageList.vue?vue&type=template&id=1b59cc92&scoped=true"
import script from "./BrandUsageList.vue?vue&type=script&lang=js"
export * from "./BrandUsageList.vue?vue&type=script&lang=js"
import style0 from "./BrandUsageList.vue?vue&type=style&index=0&id=1b59cc92&prod&scoped=true&lang=scss"
import style1 from "./BrandUsageList.vue?vue&type=style&index=1&id=1b59cc92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59cc92",
  null
  
)

export default component.exports